.page { display: flex; min-height: 100vh; }
.brandSide { position: relative; box-sizing: border-box; width: min(760px, 52.8vw); min-width: 0; flex: none; display: flex; flex-direction: column; justify-content: space-between; padding: 48px 56px; background: var(--ink); color: var(--paper); }
.hero { display: flex; flex-direction: column; align-items: flex-start; gap: 24px; }
.sticker { align-self: flex-end; padding: 8px 14px; background: var(--amber); border: 2px solid var(--paper); font-family: var(--font-cond); font-size: 18px; font-weight: 900; color: var(--ink); }
.proof { display: flex; flex-wrap: wrap; gap: 16px 36px; margin: 0; }
.proofItem { display: flex; flex-direction: column-reverse; gap: 2px; }
.proofValue { margin: 0; font-family: var(--font-cond); font-size: 44px; font-weight: 900; color: var(--paper); }
.proofKey { font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--paper-60); }
.formSide { flex: 1; min-width: 0; box-sizing: border-box; display: flex; align-items: center; justify-content: center; padding: 48px; }
.form { width: min(420px, 100%); display: flex; flex-direction: column; gap: 18px; }
.head { display: flex; flex-direction: column; gap: 2px; }
.eyebrow { margin: 0; font-family: var(--font-mono); font-size: 11px; letter-spacing: 1.6px; color: var(--hot); }
.title { margin: 0; font-family: var(--font-cond); font-size: 64px; font-weight: 900; letter-spacing: -2.5px; line-height: 1; }
.strava { display: flex; justify-content: center; }
.divider { display: flex; align-items: center; gap: 12px; font-family: var(--font-mono); font-size: 9px; letter-spacing: 1.2px; color: var(--text-secondary); }
.divider::before, .divider::after { content: ''; flex: 1; height: 1px; background: var(--line); }
.field { display: flex; flex-direction: column; gap: 6px; }
.label { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.3px; }
.input { padding: 14px; border: var(--border-control); background: var(--paper); font-family: var(--font-sans); font-size: 15px; }
.switch { align-self: flex-end; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--hot); }

@media (max-width: 1023px) {
  .page { flex-direction: column; min-height: 0; }
  .brandSide { width: auto; justify-content: flex-start; gap: 28px; padding: 32px 24px; }
  .formSide { flex: none; padding: 32px 24px; }
}

@media (max-width: 639px) {
  .brandSide { gap: 22px; padding: 12px 16px 28px 16px; }
  .hero { gap: 22px; }
  .sticker { order: 1; align-self: flex-start; padding: 6px 12px; font-size: 16px; }
  .proof { flex-wrap: nowrap; gap: 16px; }
  .proofItem { flex: 1; min-width: 0; gap: 2px; }
  .proofValue { font-size: 36px; }
  .proofKey { line-height: 1.4; letter-spacing: 1px; }
  .formSide { display: block; padding: 28px 16px 16px 16px; }
  .form { width: 100%; gap: 16px; }
  .title { font-size: 48px; letter-spacing: -2px; }
  .strava { min-height: 52px; align-items: center; }
  .input { box-sizing: border-box; height: 48px; padding: 0 14px; }
  .switch { align-self: stretch; display: flex; align-items: center; justify-content: flex-end; min-height: 44px; color: var(--text-secondary); }
}
